import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Header from '../Common_Files/Header';
import Footer from '../Common_Files/Footer';
import config from '../Common_Files/Config';
import ViewSupplier from '../Master/ViewSupplier';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import { format } from 'date-fns';

const reportCell = (value) => {
  if (value == null || value === 'null') {
    return '';
  }
  return value;
};

const PurchaseReport = () => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const paymentTableRef = useRef(null);

  const handleDateChange = (dates) => {
    if (dates && dates.length === 2) {
      const [start, end] = dates;
      setFromDate(format(start, 'yyyy-MM-dd'));
      setToDate(format(end, 'yyyy-MM-dd'));
    } else {
      setFromDate('');
      setToDate('');
    }
  };

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      window.location.href = '/login';
      return;
    }

    const $paymentTable = $(paymentTableRef.current);
    if ($.fn.DataTable.isDataTable($paymentTable)) {
      $paymentTable.DataTable().destroy();
    }

    const paymentTable = $paymentTable.DataTable({
      serverSide: true,
      processing: true,
      ajax: {
        url: `${config.api_url}/ws-purchase-payment-report-list`,
        type: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        data: (d) => ({
          ...d,
          searchByFromdate: fromDate,
          searchByTodate: toDate,
          searchValue,
        }),
        dataSrc: 'data',
      },
      columns: [
        { data: 'payment_date', render: reportCell },
        { data: 'reference_no', render: reportCell },
        { data: 'bill_no', render: reportCell },
        { data: 'job_ref', render: reportCell },
        { data: 'supplier_name', render: reportCell },
        { data: 'transaction_ref', render: reportCell },
        { data: 'payment_amount', className: 'text-end', render: reportCell },
        { data: 'remaining_balance', className: 'text-end', render: reportCell },
        { data: 'bank_name', render: reportCell },
        { data: 'details', render: reportCell },
      ],
      pageLength: 50,
      lengthMenu: [10, 25, 50, 100],
      ordering: false,
    });

    return () => {
      paymentTable.destroy();
    };
  }, [fromDate, toDate, searchValue]);

  return (
    <div>
      <Header />
      <ViewSupplier />
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <Link to="/Dashboard"><i className="fa fa-home" /></Link> &gt;
              <Link to="/Dashboard">Dashboard</Link> &gt;
              <span className="last-crumb">Purchase Payment History</span>
            </div>
          </div>
        </div>
      </div>
      <div className="main-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="dashboard">
                <div className="topsearch-area">
                  <div className="row">
                    <div className="col-lg-5 col-md-6">
                      <div className="row mb-2">
                        <label className="col-sm-4 col-form-label">P.O ID / Supplier</label>
                        <div className="col-sm-8">
                          <input
                            type="text"
                            className="search-area form-control"
                            placeholder="Search"
                            autoComplete="off"
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="row mb-2">
                        <label className="col-sm-3 col-form-label">Date Range</label>
                        <div className="col-sm-9">
                          <DateRangePicker
                            value={[fromDate ? new Date(fromDate) : null, toDate ? new Date(toDate) : null]}
                            onChange={handleDateChange}
                            format="dd/MM/yyyy"
                            editable={false}
                            placeholder="DD/MM/YYYY - DD/MM/YYYY"
                            cleanable
                            style={{ width: '100%' }}
                            onClean={() => {
                              setFromDate('');
                              setToDate('');
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="vertical-scrl-wrapper common-table" id="style-3">
                  <table className="table table-bordered dataTable" id="purchasePaymentTable" ref={paymentTableRef}>
                    <thead>
                      <tr>
                        <th>Payment Date</th>
                        <th>P.O ID</th>
                        <th>Bill No</th>
                        <th>Job Ref</th>
                        <th>Supplier</th>
                        <th>Transaction Ref</th>
                        <th>Amount Paid</th>
                        <th>Balance</th>
                        <th>Bank</th>
                        <th>Details</th>
                      </tr>
                    </thead>
                    <tbody />
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PurchaseReport;
